module.exports = __webpack_public_path__ + "img/portal--icon.ff9ff9ee.svg";